













import Vue from "vue";
import iwInputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({
    components: {
        iwInputNumber: iwInputNumber
    },
    data: function() {
        return {
            pathInStore: "property.specificities.industrial.minAvailableHeight",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["INDUSTRY"].indexOf(this.getPropertyType()) !== - 1;
        },
        minAvailableHeight: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        }
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(minAvailableHeight: number): void {
            if (minAvailableHeight === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": minAvailableHeight});
            }
        }
    },
});

